import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import * as React from 'react';
import { s as skeletonStyles } from '../../skeleton.module-7c98b8f8.js';
import { TableBody } from './TableBody.js';
import { T as TableHeader } from '../../index-34719664.js';
import { TableRow } from './TableRow.js';
import { D as DEFAULT_NUM_SKELETON_ROWS, a as DEFAULT_ROW_HEIGHT, b as DEFAULT_HEADER_HEIGHT } from '../../constants-6bdfc539.js';
import { s as styles } from '../../DataTable.module-bf72b311.js';
export { T as TableCell } from '../../index-83fc3c9d.js';
import '../../CloseIcon-25692563.js';
import '../../countries-34fea817.js';
import '../../index-177b9d11.js';
import '../../useId-f4885202.js';
import '../../CheckIcon-322b1ac3.js';
import '../../RowContext-011972fb.js';
import './Typography.js';
import '../../ChevronRightIcon-b72559d2.js';
import './Tooltip.js';
import '../../index-b7606a36.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import './IconButton.js';
import './TextLink.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../InfoIcon-22134611.js';
import '../../ThemeProvider-e3ab770b.js';

function DataTable(props) {
    var _a, _b;
    var caption = props.caption, className = props.className, rowsInfo = props.rowsInfo, columnDefs = props.columnDefs, sortKey = props.sortKey, sortDirection = props.sortDirection, onSort = props.onSort, isLayoutAuto = props.isLayoutAuto, isSkeleton = props.isSkeleton, _c = props.skeletonRows, skeletonRows = _c === void 0 ? DEFAULT_NUM_SKELETON_ROWS : _c, _d = props.skeletonRowHeight, skeletonRowHeight = _d === void 0 ? DEFAULT_ROW_HEIGHT : _d, _e = props.skeletonHeaderHeight, skeletonHeaderHeight = _e === void 0 ? DEFAULT_HEADER_HEIGHT : _e, hasBorder = props.hasBorder, otherProps = __rest(props, ["caption", "className", "rowsInfo", "columnDefs", "sortKey", "sortDirection", "onSort", "isLayoutAuto", "isSkeleton", "skeletonRows", "skeletonRowHeight", "skeletonHeaderHeight", "hasBorder"]);
    var skeletonStyle = {
        height: skeletonRows * skeletonRowHeight + skeletonHeaderHeight,
    };
    return (React.createElement("div", __assign({ "aria-busy": isSkeleton, className: classNames(styles.container, className, (_a = {},
            _a[skeletonStyles.skeleton] = isSkeleton,
            _a[styles.skeleton] = isSkeleton,
            _a[styles.withBorder] = hasBorder,
            _a)) }, otherProps, { style: isSkeleton ? skeletonStyle : undefined }),
        React.createElement("table", { className: classNames(styles.table, (_b = {},
                _b[styles.layoutAuto] = isLayoutAuto,
                _b)) },
            caption && (React.createElement("caption", { className: styles.visuallyHidden }, caption)),
            React.createElement("thead", null,
                React.createElement(TableRow, null, columnDefs.map(function (def, i) { return (React.createElement(TableHeader, { key: i, className: def.className, colWidth: def.colWidth, isSort: !!def.sortable, currentSortKey: sortKey, sortKey: def.key, sortDirection: sortDirection, label: def.label, "aria-label": def.ariaLabel, align: def.headerAlign, typographyVariant: def.typographyVariant, typographyClassName: def.typographyClassName, onClick: function (e) {
                        e.preventDefault();
                        if (onSort && def.sortable) {
                            onSort(def.key);
                        }
                    } })); }))),
            React.createElement(TableBody, { rowsInfo: rowsInfo, columnDefs: columnDefs }))));
}

export { DataTable, TableBody, TableHeader, TableRow };
